<template>
    <div class="row">
        <div class="col-12">
            <s-i-p-devices-table v-on:show-settings="showSettings"
                                 v-on:show-emergency="showEmergency"
            ></s-i-p-devices-table>
        </div>
        <SIPDeviceSettingsModal :sipdevice="selectedSipDevice" v-on:update-show="updateShow"
                                :show.sync="showModal"></SIPDeviceSettingsModal>

        <EmergencyCallingModal :sipdevice="selectedSipDevice" v-on:update-show="updateEmergencyShow"
                               :show.sync="showEmergencyModal"></EmergencyCallingModal>
    </div>

</template>

<script>
import SIPDevicesTable from "./SIPDevicesTable";
import SIPDeviceSettingsModal from "./SIPDeviceSettingsModal";
import EmergencyCallingModal from "./EmergencyCallingModal";

export default {
    components: {
        SIPDeviceSettingsModal,
        EmergencyCallingModal,
        SIPDevicesTable: SIPDevicesTable
    },
    data() {
        return {
            selectedSipDevice: null,
            showModal: false,
            showEmergencyModal: false,
        };
    },
    computed: {
        enableRTL() {
            return this.$route.query.enableRTL;
        },
        isRTL() {
            return this.$rtl.isRTL;
        },

    },
    methods: {
        showSettings(sipdevice) {
            this.selectedSipDevice = sipdevice;
            this.showModal = true;
        },
        showEmergency(sipdevice) {
            this.selectedSipDevice = sipdevice;
            this.showEmergencyModal = true;
        },
        updateShow(value) {
            this.showModal = value;
        },
        updateEmergencyShow(value) {
            this.showEmergencyModal = value;
        },
        // test(sipdevice) {
        //     let loading = this.$notify({
        //         position: 'top-right',
        //         message: 'Attempting to call ' + sipdevice,
        //         type: "info",
        //         title: "Trying..."
        //     });
        //
        //     this.$store.dispatch('sipdevice/test', {sipdevice}).then(() => {
        //         this.$notify({
        //             position: 'top-right',
        //             message: sipdevice + ' is reachable',
        //             type: "success",
        //             title: "Success!"
        //         });
        //     }).catch(() => {
        //         this.$notify({
        //             position: "bottom-right",
        //             message: sipdevice + ' is unreachable!',
        //             type: "error",
        //             title: "Unreachable!"
        //         });
        //     }).finally(() => {
        //         loading.close();
        //     });
        // },
        // reboot(sipdevice) {
        //     let loading = this.$notify({
        //         position: 'top-right',
        //         message: 'Attempting to reboot ' + sipdevice,
        //         type: "info",
        //         icon: "fal fa-spinner-third fa-spin",
        //         title: "Trying to reboot!"
        //     });
        //
        //     this.$store.dispatch('sipdevice/reboot', {sipdevice}).then(() => {
        //         this.$notify({
        //             position: 'top-right',
        //             message: sipdevice + ' is being rebooted!',
        //             type: "success",
        //             icon: "fal fa-power-off",
        //             title: "Rebooting!"
        //         });
        //     }).catch(() => {
        //         this.$notify({
        //             position: "bottom-right",
        //             message: sipdevice + ' failed to reboot!',
        //             type: "error",
        //             icon: "fal fa-times",
        //             title: "Error!"
        //         });
        //     }).finally(() => {
        //         loading.close();
        //     });
        // }
    },
    mounted() {
        this.i18n = this.$i18n;
        if (this.enableRTL) {
            this.i18n.locale = 'ar';
            this.$rtl.enableRTL();
        }


    },
    beforeDestroy() {
        if (this.$rtl.isRTL) {
            this.i18n.locale = 'en';
            this.$rtl.disableRTL();
        }
    }
};
</script>
<style></style>
